<mat-toolbar>
  <pd-branding/>
  <div class="actions">
    <ng-container *ngTemplateOutlet="startFromHereTemplate"/>

    <div
      class="origin-wrapper"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (pointerenter)="showProfile()"
      (pointerleave)="leaveButton()">

      <button
        mat-stroked-button
        class="pd-icon-button cursor-pointer"
        (click)="onProfileClick($event)">
        <mat-icon
          class="!m-0"
          piniSvgIconType="fill"
          svgIcon="user">
        </mat-icon>
      </button>
    </div>

    <button class="pd-icon-button burger" mat-stroked-button color="primary" (click)="menuOpened.emit()">
      <i class="icon-burger"></i>
    </button>
  </div>
</mat-toolbar>

<ng-template #startFromHereTemplate>
  @if (userSettingsStore.currencySettings(); as settings) {
    <mat-select placeholder="..." [panelWidth]="75" class="selected-currency"
                panelClass="selected-currency-custom-select"
                hideSingleSelectionIndicator="true"
                [disabled]="userSettingsStore.updatingDefaultCurrency()"
                [value]="settings.defaultCurrencyId"
                (valueChange)="setDefaultCurrency($event)">
      @for (currency of settings.exchangeRates; track currency.id) {
        <mat-option [value]="currency.id">{{ currency.code }}</mat-option>
      }
    </mat-select>
  } @else if (userSettingsStore.loading()) {
    <span class="skeleton span-skeleton"></span>
  } @else {
    <button class="pd-icon-button" mat-stroked-button color="primary" (click)="refresh()">
      <i class="icon-refresh"></i>
    </button>
  }
</ng-template>


<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="profileOpen"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPositions]="positions">

  <div
    class="profile-menu-panel"
    (pointerenter)="enterPanel()"
    (pointerleave)="leavePanel()">
    <app-profile-menu></app-profile-menu>

  </div>

</ng-template>


